
<button *ngIf="options.closeButton" 
        (click)="remove()" type="button" 
        class="toast-close-button ms-1" 
        aria-label="Close">
    <span aria-hidden="true">&times;</span>
</button>

<div role="alert"  [attr.aria-label]="message">        
    <presenter [data]="toastPackage.config.payload.content" />        
</div>

<div *ngIf="options.progressBar">
    <div class="toast-progress" [style.width]="width() + '%'"></div>
</div>
